
export const finwellSteps = [
    {
        content: <><b id="joyRideWelcome"></b><br /><br /><p>This Tour Guide helps you understand the features of the PwC Envision platform. Select <b>Next</b> to start a quick tour and <b>Skip</b> to leave the tour at anytime.</p></>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
        placement: 'center',
        target: 'body',
    },
    {
        target: '#heroBanner',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Stay in the know</h6>,
        content: <p>Check out featured events, updates, or tips, right here at the top. We keep this space updated with what’s most relevant.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> }
    },
    {
        target: '#moneyJourneyProgress',
        placement: 'top',
        title: <h6 style={{ fontWeight: '700' }}>Track Your Progress</h6>,
        content: <p>This bar shows how far you've come. Here you’re going to find your first key steps. Complete these actions to set up your experience and get the most relevant content.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> }
    },
    // {
    //     target: '#momentumTracker',
    //     placement: 'top',
    //     title: <h6 style={{ fontWeight: '700' }}>Build Your Financial Habit</h6>,
    //     content: <p>Keep your streak going! Each month you engage moves you closer to your financial goals.</p>,
    //     locale: { skip: <strong aria-label="skip">Skip</strong> }
    // },
    {
        target: '#activityRings',
        placement: 'top',
        title: <h6 style={{ fontWeight: '700' }}>Track How You Engage</h6>,
        content: <p>These rings show your activity across learning, planning, and action.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> }
    },
    {
        target: '#coachingModule',
        placement: 'top',
        title: <h6 style={{ fontWeight: '700' }}>Get Expert Support</h6>,
        content: <p>Work with a financial coach to build a plan, stay motivated, and get one-on-one guidance when you need it.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> }
    },
    {
        target: '#forYouSection',
        placement: 'top',
        title: <h6 style={{ fontWeight: '700' }}>Recommended for You</h6>,
        content: <p>Based on your interests, goals, and past activity, these resources are hand-picked to help you move forward.</p>,
        locale: { last: <strong aria-label="last">Finish</strong> }
    }
]


export const joyRideSteps = [
    {
        content: <><b id="joyRideWelcome"></b><br /><br /><p>This Tour Guide helps you understand the features of the Xsel platform. Select <b>Next</b> to start a quick tour and <b>Skip</b> to leave the tour at anytime.</p></>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
        placement: 'center',
        target: 'body',
    },
    {
        target: '#idMyAccountWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Profile</h6>,
        content: <p>Your profile details appear under <b>Profile</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idSettingsWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Change Password</h6>,
        content: <p>You may <b>Change Password</b> of your account here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    // {
    //     target: '#idLearningWeb',
    //     placement: 'left',
    //     title: <h6 style={{ fontWeight: '700' }}>Learning</h6>,
    //     content: <p>You can <b>Learning</b> if you have a Basic account.</p>,
    //     locale: { skip: <strong aria-label="skip">Skip</strong> },
    // },
    {
        target: '#idAchieveWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Achievements</h6>,
        content: <p>Your <b>Achievements</b> including rankings, certificates, and badges, are displayed here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    // {
    //     target: '#idRewardPointsWeb',
    //     placement: 'left',
    //     title: <h6 style={{ fontWeight: '700' }}>Reward Points</h6>,
    //     content: <p>Your <b>Reward Points</b> appear here. You earn these points when you purchase services on the platform. You can use your <b>Reward Points</b> to purchase additional services on the platform.</p>,
    //     locale: { skip: <strong aria-label="skip">Skip</strong> },
    // },
    {
        target: '#idOrdersWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Orders</h6>,
        content: <p>Your purchase and details of <b>Orders</b> history appear here. </p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idWishListWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Wishlist</h6>,
        content: <p>You can create & see your <b>Wishlist</b> from here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCodeOfEthicsWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Code of Ethics</h6>,
        content: <p>Your <b>Code of Ethics</b> appears here. Code of Ethics is a collection of rules and principles designed to foster ethical behaviour within the realm of Real Estate.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCoursesWeb',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Learn</h6>,
        content: <p>You may review the available <b>Learn</b> and their respective categories here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCoursesMenu',
        placement: 'right',
        title: <h6 style={{ fontWeight: '700' }}>Courses</h6>,
        // spotlightClicks: true,
        content: <p>You may review the available <b>Courses</b> and their respective categories here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCategoryList',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Category List</h6>,
        // spotlightClicks: true,
        content: <p>All the <b>Categories</b> are presented here. <b>Select your preferred category from the given options</b></p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCourseList',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Courses</h6>,
        // spotlightClicks: true,
        content: <p>You can further Categorise, as well as Filter, Sort, and Search through the listed <b>Courses</b> before you select your preferred course.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },

    },
    {
        target: '#idModuleDetail',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Menu</h6>,
        // spotlightClicks: true,
        content: <p><b>Menu</b> reflects all the modules of the selected course.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idVideosMenu',
        placement: 'right',
        title: <h6 style={{ fontWeight: '700' }}>Videos</h6>,
        content: <p>You may review the available <b>Videos</b> and their respective categories here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCoachingMenu',
        placement: 'right',
        title: <h6 style={{ fontWeight: '700' }}>Coaching</h6>,
        content: <p>The list of coach appears under <b>Coaching</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCertificationsMenu',
        placement: 'right',
        title: <h6 style={{ fontWeight: '700' }}>Certifications</h6>,
        content: <p>The list of certification events appears under <b>Certifications</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idRolePlayMenu',
        placement: 'right',
        title: <h6 style={{ fontWeight: '700' }}>Role play</h6>,
        content: <p>You may visit the <b>Role play</b> section from here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idRoleplayScen',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Role play scenarios</h6>,
        spotlightClicks: true,
        content: <p>Role plays that are part of your subscription package are available under <b>Role play scenarios</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idYourRoleplay',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>My role plays</h6>,
        content: <p><b>My role plays</b> displays your participation status details.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idRolePlayMyResponse',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>My Response</h6>,
        content: <p>You may record and upload your response here. You may choose between Record Video, Upload Video, or Upload Audio under <b>My Response</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idEventsMenu',
        placement: 'top',
        title: <h6 style={{ fontWeight: '700' }}>Events</h6>,
        content: <p>The <b>Events</b> list and the Sessions scheduled for each event are presented here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idEventListing',
        placement: 'top',
        title: <h6 style={{ fontWeight: '700' }}>Event Card</h6>,
        spotlightClicks: true,
        content: <p><b>Event Card</b> displays descriptions of the Events here. You can access a Session list by selecting the relevant Event Card.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idComboMenu',
        placement: 'top',
        title: <h6 style={{ fontWeight: '700' }}>Combo & Offers</h6>,
        spotlightClicks: true,
        content: <p>Coming soon!.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idPartnerMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Partner</h6>,
        content: <p>The list of partner appears under <b>Partners</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idLiveBtnMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Live Button</h6>,
        content: <p><b>Live Button</b> begins to blink 15 minutes before a Session is about to start.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idSearchMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Search</h6>,
        content: <p>You can <b>Search</b> for any learning component (Course, Video, or Event) here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCartMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Cart</h6>,
        content: <p>Content coming soon!</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCalendarMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Calendar</h6>,
        content: <p>Your <b>Calendar</b> displays all the Sessions relevant to your learning.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idNotificationMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Notifications</h6>,
        content: <p>You receive alerts on the bell icon when there are <b>Notifications</b> for you.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idMyWall',
        placement: 'top',
        title: <h6 style={{ fontWeight: '700' }}>My Wall</h6>,
        content: <p><b>My Wall</b> displays your colleagues' posts. You can post, like, and comment on the feeds.</p>,
    },
]

export const joyRideStepsPremium = [
    {
        content: <><b id="joyRideWelcome"></b><br /><br /><p>This Tour Guide helps you understand the features of the Xsel platform. Select <b>Next</b> to start a quick tour and <b>Skip</b> to leave the tour at anytime.</p></>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
        placement: 'center',
        target: 'body',
    },
    {
        target: '#idMyAccountWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>My Account</h6>,
        content: <p>Your profile details appear under <b>My Account</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idRewardPointsWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Reward Points</h6>,
        content: <p>Your <b>Reward Points</b> appear here. You earn these points when you purchase services on the platform. You can use your <b>Reward Points</b> to purchase additional services on the platform.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idOrdersWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Orders</h6>,
        content: <p>Your purchase and details of <b>Orders</b> history appear here. </p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idSubscriptionWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Subscription</h6>,
        content: <p>Your details of <b>Subscription</b> appear here. </p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idWishListWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Wishlist</h6>,
        content: <p>You may build your <b>Wishlist</b> here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idChangePasswordWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Change Password</h6>,
        content: <p>You may <b>Change Password</b> of your account here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCoursesWeb',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Courses</h6>,
        content: <p>You may review the available <b>Courses</b> and their respective categories here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCourseCat',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Categories</h6>,
        spotlightClicks: true,
        content: <p>All the <b>Categories</b> are presented here. <b>Select your preferred category from the given options</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
        styles: {
            buttonNext: {
                display: 'none',
            },
        }
    },
    {
        target: '#idCourseList',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Courses</h6>,
        spotlightClicks: true,
        content: <p>You can further Categorise, as well as Filter, Sort, and Search through the listed <b>Courses</b> before you select your preferred course.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },

    },
    {
        target: '#idModuleDetail',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Menu</h6>,
        spotlightClicks: true,
        content: <p><b>Menu</b> reflects all the modules of the selected course.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idVideosMenuWeb',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Videos</h6>,
        content: <p>You may review the available <b>Videos</b> and their respective categories here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idRolePlayMenuWeb',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Role play</h6>,
        content: <p>You may visit the <b>Role play</b> section from here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idRolePlayExplore',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Explore More</h6>,
        spotlightClicks: true,
        content: <p>Role plays that are part of your subscription package are available under <b>Explore More</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idRolePlayMyResponse',
        placement: 'right',
        title: <h6 style={{ fontWeight: '700' }}>My Response</h6>,
        spotlightClicks: true,
        content: <p>You may record and upload your response here. You may choose between Record Video, Upload Video, or Upload Audio under <b>My Response</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idParticipationSummary',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>My Participation Summary</h6>,
        content: <p><b>My Participation Summary</b> displays your participation status details.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCoachingSummary',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>My Coaching Summary</h6>,
        content: <p><b>My Coaching Summary</b> displays your feedback status details.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idEventsMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Events</h6>,
        content: <p>The <b>Events</b> list and the Sessions scheduled for each event are presented here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idEventListing',
        placement: 'top',
        title: <h6 style={{ fontWeight: '700' }}>Event Card</h6>,
        spotlightClicks: true,
        content: <p><b>Event Card</b> displays descriptions of the Events here. You can access a Session list by selecting the relevant Event Card.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCertificationsMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Certifications</h6>,
        content: <p>The list of certification events appears under <b>Certifications</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCoachingMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Coaching</h6>,
        content: <p>The list of coach appears under <b>Coaching</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idPartnerMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Partners</h6>,
        content: <p>The list of partner appears under <b>Partners</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idMoreMenu',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>More</h6>,
        content: <p><b>More</b> opens into a list of resources and assets like My Toolbox and My Network to further aid your learning.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idtoolboxWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>My Toolbox</h6>,
        content: <p><b>My Toolbox</b> lets you review, upload, edit, and download all your PDF documents and resources.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idrole-requestWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>My Network</h6>,
        content: <p><b>My Network</b> displays a list of your team members and any pending requests to join a team if you are a Coach, Mentor, Team Lead, or Manager within a Brokerage.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idmy-onboardingWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Onboarding</h6>,
        content: <p>You can review your <b>Onboarding</b> Action Path here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idlearning-pathWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Action Path</h6>,
        content: <p>All the assigned as well as other <b>Action Paths</b> are available here for your reference.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idcoursesWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Courses</h6>,
        content: <p><b>Courses</b> that are assigned to you are available here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idvideosWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Videos</h6>,
        content: <p><b>Videos</b> that are assigned to you are available here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#ideventsWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Events</h6>,
        content: <p>All your registered <b>Events</b> can be found here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idmy-certificatesWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Certificates</h6>,
        content: <p>You may review your <b>Certificates</b> here once you have completed the Onboarding and Action Path.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idmy-badgesWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Badges</h6>,
        content: <p><b>Badges</b> are awarded to you after the completion of each paid course. All the awarded <b>Badges</b> are available here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idlearning-pointsWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Learning Points</h6>,
        content: <p><b>Learning Points</b> are awarded to you as you complete Courses, Videos, and Role plays and they are accumulated here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idSearchMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Search</h6>,
        content: <p>You can <b>Search</b> for any learning component (Course, Video, or Event) here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idLiveBtnMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Live Button</h6>,
        content: <p><b>Live Button</b> begins to blink 15 minutes before a Session is about to start.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCalendarMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Calendar</h6>,
        content: <p>Your <b>Calendar</b> displays all the Sessions relevant to your learning.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idNotificationMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Notifications</h6>,
        content: <p>You receive alerts on the bell icon when there are <b>Notifications</b> for you.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idMyWall',
        placement: 'top',
        title: <h6 style={{ fontWeight: '700' }}>My Wall</h6>,
        content: <p><b>My Wall</b> displays your colleagues' posts. You can post, like, and comment on the feeds.</p>,
    },
]

export const joyRideStepsManager = [
    {
        content: <><b id="joyRideWelcome"></b><br /><br /><p>This Tour Guide helps you understand the features of the Xsel platform. Select <b>Next</b> to start a quick tour and <b>Skip</b> to leave the tour at anytime.</p></>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
        placement: 'center',
        target: 'body',
    },
    {
        target: '#idMyAccountMngWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>My Account</h6>,
        content: <p>Your profile details appear under <b>My Account</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    // {
    //     target: '#idUpgradeToPremiumMngWeb',
    //     placement: 'left',
    //     title: <h6 style={{ fontWeight: '700' }}>Upgrade to Premium</h6>,
    //     content: <p>You can <b>Upgrade to Premium</b> if you have a Basic account.</p>,
    //     locale: { skip: <strong aria-label="skip">Skip</strong> },
    // },
    {
        target: '#idSettingsMngWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Change Password</h6>,
        content: <p>You may <b>Change Password</b> of your account here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idAchieveMngWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Achievements</h6>,
        content: <p>Your <b>Achievements</b> including rankings, certificates, and badges, are displayed here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    // {
    //     target: '#idRewardPointsMngWeb',
    //     placement: 'left',
    //     title: <h6 style={{ fontWeight: '700' }}>Reward Points</h6>,
    //     content: <p>Your <b>Reward Points</b> appear here. You earn these points when you purchase services on the platform. You can use your <b>Reward Points</b> to purchase additional services on the platform.</p>,
    //     locale: { skip: <strong aria-label="skip">Skip</strong> },
    // },
    {
        target: '#idOrdersMngWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Orders</h6>,
        content: <p>Your purchase and details of <b>Orders</b> history appear here. </p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idWishListMngWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Wishlist</h6>,
        content: <p>You can create & see your <b>Wishlist</b> from here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idMyReportMngWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Reports</h6>,
        content: <p>You may review all user learning progression <b>Reports</b> here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCodeOfEthicsMngWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Code of Ethics</h6>,
        content: <p>Your <b>Code of Ethics</b> appears here. Code of Ethics is a collection of rules and principles designed to foster ethical behaviour within the realm of Real Estate.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idMyCommunityMngWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>My Community</h6>,
        content: <p><b>My Community</b> displays a list of your team members and any pending requests to join a team if you are a Coach, Mentor, Team Lead, or Manager within a Brokerage.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCoursesWeb',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Learn</h6>,
        content: <p>You may review the available <b>Learn</b> and their respective categories here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCoursesMenu',
        placement: 'right',
        title: <h6 style={{ fontWeight: '700' }}>Courses</h6>,
        // spotlightClicks: true,
        content: <p>You may review the available <b>Courses</b> and their respective categories here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCategoryList',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Category List</h6>,
        // spotlightClicks: true,
        content: <p>All the <b>Categories</b> are presented here. <b>Select your preferred category from the given options</b></p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCourseList',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Courses</h6>,
        // spotlightClicks: true,
        content: <p>You can further Categorise, as well as Filter, Sort, and Search through the listed <b>Courses</b> before you select your preferred course.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },

    },
    {
        target: '#idModuleDetail',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Menu</h6>,
        // spotlightClicks: true,
        content: <p><b>Menu</b> reflects all the modules of the selected course.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idVideosMenu',
        placement: 'right',
        title: <h6 style={{ fontWeight: '700' }}>Videos</h6>,
        content: <p>You may review the available <b>Videos</b> and their respective categories here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCoachingMenu',
        placement: 'right',
        title: <h6 style={{ fontWeight: '700' }}>Coaching</h6>,
        content: <p>The list of coach appears under <b>Coaching</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCertificationsMenu',
        placement: 'right',
        title: <h6 style={{ fontWeight: '700' }}>Certifications</h6>,
        content: <p>The list of certification events appears under <b>Certifications</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idRolePlayMenu',
        placement: 'right',
        title: <h6 style={{ fontWeight: '700' }}>Role play</h6>,
        content: <p>You may visit the <b>Role play</b> section from here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idRoleplayScen',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Role play scenarios</h6>,
        spotlightClicks: true,
        content: <p>Role plays that are part of your subscription package are available under <b>Role play scenarios</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idYourRoleplay',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>My role plays</h6>,
        content: <p><b>My role plays</b> displays your participation status details.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idRolePlayMyResponse',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>My Response</h6>,
        content: <p>You may record and upload your response here. You may choose between Record Video, Upload Video, or Upload Audio under <b>My Response</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idEventsMenu',
        placement: 'top',
        title: <h6 style={{ fontWeight: '700' }}>Events</h6>,
        content: <p>The <b>Events</b> list and the Sessions scheduled for each event are presented here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idEventListing',
        placement: 'top',
        title: <h6 style={{ fontWeight: '700' }}>Event Card</h6>,
        spotlightClicks: true,
        content: <p><b>Event Card</b> displays descriptions of the Events here. You can access a Session list by selecting the relevant Event Card.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idComboMenu',
        placement: 'top',
        title: <h6 style={{ fontWeight: '700' }}>Combo & Offers</h6>,
        spotlightClicks: true,
        content: <p>Coming soon!.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idPartnerMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Partner</h6>,
        content: <p>The list of partner appears under <b>Partners</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idLiveBtnMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Live Button</h6>,
        content: <p><b>Live Button</b> begins to blink 15 minutes before a Session is about to start.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idSearchMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Search</h6>,
        content: <p>You can <b>Search</b> for any learning component (Course, Video, or Event) here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCartMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Cart</h6>,
        content: <p>Content coming soon!</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCalendarMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Calendar</h6>,
        content: <p>Your <b>Calendar</b> displays all the Sessions relevant to your learning.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idNotificationMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Notifications</h6>,
        content: <p>You receive alerts on the bell icon when there are <b>Notifications</b> for you.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idMyWall',
        placement: 'top',
        title: <h6 style={{ fontWeight: '700' }}>My Wall</h6>,
        content: <p><b>My Wall</b> displays your colleagues' posts. You can post, like, and comment on the feeds.</p>,
    },

    
]

export const joyRideStepsManagerPremium = [
    {
        content: <><b id="joyRideWelcome"></b><br /><br /><p>This Tour Guide helps you understand the features of the Xsel platform. Select <b>Next</b> to start a quick tour and <b>Skip</b> to leave the tour at anytime.</p></>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
        placement: 'center',
        target: 'body',
    },
    {
        target: '#idMyAccountMngWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>My Account</h6>,
        content: <p>Your profile details appear under <b>My Account</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idRewardPointsMngWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Reward Points</h6>,
        content: <p>Your <b>Reward Points</b> appear here. You earn these points when you purchase services on the platform. You can use your <b>Reward Points</b> to purchase additional services on the platform.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idOrdersMngWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Orders</h6>,
        content: <p>Your purchase and details of <b>Orders</b> history appear here. </p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idSubscriptionMngWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Subscription</h6>,
        content: <p>Your details of <b>Subscription</b> appear here. </p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idWishListMngWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Wishlist</h6>,
        content: <p>You may build your <b>Wishlist</b> here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idChangePasswordMngWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Change Password</h6>,
        content: <p>You may <b>Change Password</b> of your account here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCoursesWeb',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Courses</h6>,
        content: <p>You may review the available <b>Courses</b> and their respective categories here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCourseCat',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Categories</h6>,
        spotlightClicks: true,
        content: <p>All the <b>Categories</b> are presented here. <b>Select your preferred category from the given options</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
        styles: {
            buttonNext: {
                display: 'none',
            },
        }
    },
    {
        target: '#idCourseList',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Courses</h6>,
        spotlightClicks: true,
        content: <p>You can further Categorise, as well as Filter, Sort, and Search through the listed <b>Courses</b> before you select your preferred course.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },

    },
    {
        target: '#idModuleDetail',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Menu</h6>,
        spotlightClicks: true,
        content: <p><b>Menu</b> reflects all the modules of the selected course.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idVideosMenuWeb',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Videos</h6>,
        content: <p>You may review the available <b>Videos</b> and their respective categories here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idRolePlayMenuWeb',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Role play</h6>,
        content: <p>You may visit the <b>Role play</b> section from here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idRolePlayExplore',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Explore More</h6>,
        spotlightClicks: true,
        content: <p>Role plays that are part of your subscription package are available under <b>Explore More</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idRolePlayMyResponse',
        placement: 'right',
        title: <h6 style={{ fontWeight: '700' }}>My Response</h6>,
        spotlightClicks: true,
        content: <p>You may record and upload your response here. You may choose between Record Video, Upload Video, or Upload Audio under <b>My Response</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idParticipationSummary',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>My Participation Summary</h6>,
        content: <p><b>My Participation Summary</b> displays your participation status details.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCoachingSummary',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>My Coaching Summary</h6>,
        content: <p><b>My Coaching Summary</b> displays your feedback status details.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idEventsMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Events</h6>,
        content: <p>The <b>Events</b> list and the Sessions scheduled for each event are presented here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idEventListing',
        placement: 'top',
        title: <h6 style={{ fontWeight: '700' }}>Event Card</h6>,
        spotlightClicks: true,
        content: <p><b>Event Card</b> displays descriptions of the Events here. You can access a Session list by selecting the relevant Event Card.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCertificationsMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Certifications</h6>,
        content: <p>The list of certification events appears under <b>Certifications</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCoachingMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Coaching</h6>,
        content: <p>The list of coach appears under <b>Coaching</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idPartnerMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Partners</h6>,
        content: <p>The list of partner appears under <b>Partners</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idMoreMenu',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>More</h6>,
        content: <p><b>More</b> opens into a list of resources and assets like My Toolbox and My Network to further aid your learning.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idreportWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Reports</h6>,
        content: <p>You may review all user learning progression <b>Reports</b> here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idtoolboxWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>My Toolbox</h6>,
        content: <p><b>My Toolbox</b> lets you review, upload, edit, and download all your PDF documents and resources.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idrole-requestWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>My Network</h6>,
        content: <p><b>My Network</b> displays a list of your team members and any pending requests to join a team if you are a Coach, Mentor, Team Lead, or Manager within a Brokerage.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idmy-onboardingWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Onboarding</h6>,
        content: <p>You can review your <b>Onboarding</b> Action Path here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idlearning-pathWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Action Path</h6>,
        content: <p>All the assigned as well as other <b>Action Paths</b> are available here for your reference.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idcoursesWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Courses</h6>,
        content: <p><b>Courses</b> that are assigned to you are available here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idvideosWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Videos</h6>,
        content: <p><b>Videos</b> that are assigned to you are available here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#ideventsWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Events</h6>,
        content: <p>All your registered <b>Events</b> can be found here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idmy-certificatesWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Certificates</h6>,
        content: <p>You may review your <b>Certificates</b> here once you have completed the Onboarding and Action Path.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idmy-badgesWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Badges</h6>,
        content: <p><b>Badges</b> are awarded to you after the completion of each paid course. All the awarded <b>Badges</b> are available here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idlearning-pointsWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Learning Points</h6>,
        content: <p><b>Learning Points</b> are awarded to you as you complete Courses, Videos, and Role plays and they are accumulated here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idSearchMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Search</h6>,
        content: <p>You can <b>Search</b> for any learning component (Course, Video, or Event) here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idLiveBtnMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Live Button</h6>,
        content: <p><b>Live Button</b> begins to blink 15 minutes before a Session is about to start.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCalendarMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Calendar</h6>,
        content: <p>Your <b>Calendar</b> displays all the Sessions relevant to your learning.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idNotificationMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Notifications</h6>,
        content: <p>You receive alerts on the bell icon when there are <b>Notifications</b> for you.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idMyWall',
        placement: 'top',
        title: <h6 style={{ fontWeight: '700' }}>My Wall</h6>,
        content: <p><b>My Wall</b> displays your colleagues' posts. You can post, like, and comment on the feeds.</p>,
    },
]

export const joyRideGuestSteps = [
    {
        content: <><b id="joyRideWelcome"></b><br /><br /><p>This Tour Guide helps you understand the features of the Xsel platform. Select <b>Next</b> to start a quick tour and <b>Skip</b> to leave the tour at anytime.</p></>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
        placement: 'center',
        target: 'body',
    },
    {
        target: '#idMyAccountWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>My Account</h6>,
        content: <p>Your profile details appear under <b>My Account</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idUpgradeToPremiumWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Upgrade to Premium</h6>,
        content: <p>You can <b>Upgrade to Premium</b> if you have a Basic account.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idRewardPointsWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Reward Points</h6>,
        content: <p>Your <b>Reward Points</b> appear here. You earn these points when you purchase services on the platform. You can use your <b>Reward Points</b> to purchase additional services on the platform.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idOrdersWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Orders</h6>,
        content: <p>Your purchase and details of <b>Orders</b> history appear here. </p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idSubscriptionWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Subscription</h6>,
        content: <p>Your details of <b>Subscription</b> appear here. </p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idWishListWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Wishlist</h6>,
        content: <p>You may build your <b>Wishlist</b> here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idChangePasswordWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Change Password</h6>,
        content: <p>You may <b>Change Password</b> of your account here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCoursesWeb',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Courses</h6>,
        content: <p>You may review the available <b>Courses</b> and their respective categories here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCourseCat',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Categories</h6>,
        spotlightClicks: true,
        content: <p>All the <b>Categories</b> are presented here. <b>Select your preferred category from the given options</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
        styles: {
            buttonNext: {
                display: 'none',
            },
        }
    },
    {
        target: '#idCourseList',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Courses</h6>,
        spotlightClicks: true,
        content: <p>You can further Categorise, as well as Filter, Sort, and Search through the listed <b>Courses</b> before you select your preferred course.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },

    },
    {
        target: '#idModuleDetail',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Menu</h6>,
        spotlightClicks: true,
        content: <p><b>Menu</b> reflects all the modules of the selected course.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idVideosMenuWeb',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Videos</h6>,
        content: <p>You may review the available <b>Videos</b> and their respective categories here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idRolePlayMenuWeb',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Role play</h6>,
        content: <p>You may visit the <b>Role play</b> section from here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idRolePlayExplore',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Explore More</h6>,
        spotlightClicks: true,
        content: <p>Role plays that are part of your subscription package are available under <b>Explore More</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idRolePlayMyResponse',
        placement: 'right',
        title: <h6 style={{ fontWeight: '700' }}>My Response</h6>,
        spotlightClicks: true,
        content: <p>You may record and upload your response here. You may choose between Record Video, Upload Video, or Upload Audio under <b>My Response</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idParticipationSummary',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>My Participation Summary</h6>,
        content: <p><b>My Participation Summary</b> displays your participation status details.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCoachingSummary',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>My Coaching Summary</h6>,
        content: <p><b>My Coaching Summary</b> displays your feedback status details.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idEventsMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Events</h6>,
        content: <p>The <b>Events</b> list and the Sessions scheduled for each event are presented here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idEventListing',
        placement: 'top',
        title: <h6 style={{ fontWeight: '700' }}>Event Card</h6>,
        spotlightClicks: true,
        content: <p><b>Event Card</b> displays descriptions of the Events here. You can access a Session list by selecting the relevant Event Card.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCertificationsMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Certifications</h6>,
        content: <p>The list of certification events appears under <b>Certifications</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCoachingMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Coaching</h6>,
        content: <p>The list of coach appears under <b>Coaching</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idPartnerMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Partners</h6>,
        content: <p>The list of partner appears under <b>Partners</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idMoreMenu',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>More</h6>,
        content: <p><b>More</b> opens into a list of resources and assets like My Toolbox and My Network to further aid your learning.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idtoolboxWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>My Toolbox</h6>,
        content: <p><b>My Toolbox</b> lets you review, upload, edit, and download all your PDF documents and resources.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idmy-onboardingWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Onboarding</h6>,
        content: <p>You can review your <b>Onboarding</b> Action Path here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idlearning-pathWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Action Path</h6>,
        content: <p>All the assigned as well as other <b>Action Paths</b> are available here for your reference.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idcoursesWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Courses</h6>,
        content: <p><b>Courses</b> that are assigned to you are available here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idvideosWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Videos</h6>,
        content: <p><b>Videos</b> that are assigned to you are available here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#ideventsWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Events</h6>,
        content: <p>All your registered <b>Events</b> can be found here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idmy-certificatesWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Certificates</h6>,
        content: <p>You may review your <b>Certificates</b> here once you have completed the Onboarding and Action Path.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idmy-badgesWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Badges</h6>,
        content: <p><b>Badges</b> are awarded to you after the completion of each paid course. All the awarded <b>Badges</b> are available here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idlearning-pointsWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Learning Points</h6>,
        content: <p><b>Learning Points</b> are awarded to you as you complete Courses, Videos, and Role plays and they are accumulated here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idSearchMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Search</h6>,
        content: <p>You can <b>Search</b> for any learning component (Course, Video, or Event) here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idLiveBtnMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Live Button</h6>,
        content: <p><b>Live Button</b> begins to blink 15 minutes before a Session is about to start.</p>,

    },
    {
        target: '#idCalendarMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Calendar</h6>,
        content: <p>Your <b>Calendar</b> displays all the Sessions relevant to your learning.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idNotificationMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Notifications</h6>,
        content: <p>You receive alerts on the bell icon when there are <b>Notifications</b> for you.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
]

export const joyRideGuestStepsPremium = [
    {
        content: <><b id="joyRideWelcome"></b><br /><br /><p>This Tour Guide helps you understand the features of the Xsel platform. Select <b>Next</b> to start a quick tour and <b>Skip</b> to leave the tour at anytime.</p></>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
        placement: 'center',
        target: 'body',
    },
    {
        target: '#idMyAccountWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>My Account</h6>,
        content: <p>Your profile details appear under <b>My Account</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idRewardPointsWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Reward Points</h6>,
        content: <p>Your <b>Reward Points</b> appear here. You earn these points when you purchase services on the platform. You can use your <b>Reward Points</b> to purchase additional services on the platform.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idOrdersWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Orders</h6>,
        content: <p>Your purchase and details of <b>Orders</b> history appear here. </p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idSubscriptionWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Subscription</h6>,
        content: <p>Your details of <b>Subscription</b> appear here. </p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idWishListWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Wishlist</h6>,
        content: <p>You may build your <b>Wishlist</b> here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idChangePasswordWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Change Password</h6>,
        content: <p>You may <b>Change Password</b> of your account here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCoursesWeb',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Courses</h6>,
        content: <p>You may review the available <b>Courses</b> and their respective categories here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCourseCat',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Categories</h6>,
        spotlightClicks: true,
        content: <p>All the <b>Categories</b> are presented here. <b>Select your preferred category from the given options</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
        styles: {
            buttonNext: {
                display: 'none',
            },
        }
    },
    {
        target: '#idCourseList',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Courses</h6>,
        spotlightClicks: true,
        content: <p>You can further Categorise, as well as Filter, Sort, and Search through the listed <b>Courses</b> before you select your preferred course.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },

    },
    {
        target: '#idModuleDetail',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Menu</h6>,
        spotlightClicks: true,
        content: <p><b>Menu</b> reflects all the modules of the selected course.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idVideosMenuWeb',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Videos</h6>,
        content: <p>You may review the available <b>Videos</b> and their respective categories here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idRolePlayMenuWeb',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Role play</h6>,
        content: <p>You may visit the <b>Role play</b> section from here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idRolePlayExplore',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Explore More</h6>,
        spotlightClicks: true,
        content: <p>Role plays that are part of your subscription package are available under <b>Explore More</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idRolePlayMyResponse',
        placement: 'right',
        title: <h6 style={{ fontWeight: '700' }}>My Response</h6>,
        spotlightClicks: true,
        content: <p>You may record and upload your response here. You may choose between Record Video, Upload Video, or Upload Audio under <b>My Response</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idParticipationSummary',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>My Participation Summary</h6>,
        content: <p><b>My Participation Summary</b> displays your participation status details.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCoachingSummary',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>My Coaching Summary</h6>,
        content: <p><b>My Coaching Summary</b> displays your feedback status details.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idEventsMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Events</h6>,
        content: <p>The <b>Events</b> list and the Sessions scheduled for each event are presented here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idEventListing',
        placement: 'top',
        title: <h6 style={{ fontWeight: '700' }}>Event Card</h6>,
        spotlightClicks: true,
        content: <p><b>Event Card</b> displays descriptions of the Events here. You can access a Session list by selecting the relevant Event Card.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCertificationsMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Certifications</h6>,
        content: <p>The list of certification events appears under <b>Certifications</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idCoachingMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Coaching</h6>,
        content: <p>The list of coach appears under <b>Coaching</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idPartnerMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Partners</h6>,
        content: <p>The list of partner appears under <b>Partners</b>.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idMoreMenu',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>More</h6>,
        content: <p><b>More</b> opens into a list of resources and assets like My Toolbox and My Network to further aid your learning.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idtoolboxWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>My Toolbox</h6>,
        content: <p><b>My Toolbox</b> lets you review, upload, edit, and download all your PDF documents and resources.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idmy-onboardingWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Onboarding</h6>,
        content: <p>You can review your <b>Onboarding</b> Action Path here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idlearning-pathWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Action Path</h6>,
        content: <p>All the assigned as well as other <b>Action Paths</b> are available here for your reference.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idcoursesWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Courses</h6>,
        content: <p><b>Courses</b> that are assigned to you are available here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idvideosWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Videos</h6>,
        content: <p><b>Videos</b> that are assigned to you are available here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#ideventsWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Events</h6>,
        content: <p>All your registered <b>Events</b> can be found here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idmy-certificatesWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Certificates</h6>,
        content: <p>You may review your <b>Certificates</b> here once you have completed the Onboarding and Action Path.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idmy-badgesWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Badges</h6>,
        content: <p><b>Badges</b> are awarded to you after the completion of each paid course. All the awarded <b>Badges</b> are available here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idlearning-pointsWeb',
        placement: 'left',
        title: <h6 style={{ fontWeight: '700' }}>Learning Points</h6>,
        content: <p><b>Learning Points</b> are awarded to you as you complete Courses, Videos, and Role plays and they are accumulated here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idSearchMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Search</h6>,
        content: <p>You can <b>Search</b> for any learning component (Course, Video, or Event) here.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idLiveBtnMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Live Button</h6>,
        content: <p><b>Live Button</b> begins to blink 15 minutes before a Session is about to start.</p>,
    },
    {
        target: '#idCalendarMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Calendar</h6>,
        content: <p>Your <b>Calendar</b> displays all the Sessions relevant to your learning.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
    {
        target: '#idNotificationMenu',
        placement: 'bottom',
        title: <h6 style={{ fontWeight: '700' }}>Notifications</h6>,
        content: <p>You receive alerts on the bell icon when there are <b>Notifications</b> for you.</p>,
        locale: { skip: <strong aria-label="skip">Skip</strong> },
    },
]